export function timeZoneFormatter(timeZone: number): any {
    const minutes = timeZone * 60;
    const hours = Math.floor((Math.abs(minutes / 60))) < 10 ?
        ('0' + Math.floor((Math.abs(minutes / 60)))) : ('' + Math.floor((Math.abs(minutes / 60))));
    const min = minutes % 60 === 0 ? '00' : ('' + Math.abs(minutes % 60));
    return (timeZone >= 0 ? '+' : '-') + hours + ':' + min;
}
